import React from "react";
import { Box } from "@mui/material";
import { IItinerary, useConfig } from "@thekilroygroup/shared-ui";
import { SkyscannerTracking } from "./SkyscannerTracking";
import { ISearchForm } from "redux/searchForm";
import { GoogleFlightsTracking } from "./GoogleFlightsTracking";
import { IAppConfigObject } from "appConfig.interfaces";

export interface IProps {
  selectedItinerary: IItinerary | null;
  eventType: "pre-conversion" | "conversion";
  createdDate: string;
  paymentMethod?: string;
  totalPaidAmount?: number;
  fee?: number;
  conversion_id?: string;
  utm_source: string;
  searchQuery: ISearchForm;
  price: number;
  isDirectBooking?: boolean;
}

export const MetapartnerTracking = React.memo(
  (props: IProps) => {
    const {
      selectedItinerary,
      searchQuery: { clickId, fareId },
    } = props;

    const {
      appConfig: { SKYSCANNER_TRACKING_SOURCE_ID },
    } = useConfig<IAppConfigObject>();
    return (
      <Box>
        {props.utm_source.toLowerCase().includes("skyscanner") &&
          selectedItinerary &&
          clickId &&
          SKYSCANNER_TRACKING_SOURCE_ID && (
            <SkyscannerTracking
              fareBasis={
                selectedItinerary &&
                findAllValuesWithKey(
                  selectedItinerary.fareBreakdowns,
                  "code",
                )[0]
              }
              marketingCarrier={
                (selectedItinerary &&
                  findAllValuesWithKey(
                    selectedItinerary,
                    "marketingAirline",
                  ).join("|")) ||
                "_"
              }
              skyscannerTrackingSourceId={SKYSCANNER_TRACKING_SOURCE_ID}
              skyscannerRedirectid={clickId}
              {...props}
            />
          )}
        {props.utm_source.toLowerCase().includes("google") && (
          <GoogleFlightsTracking
            {...props}
            fareId={fareId}
            googlePartnerId="GF-1072"
          />
        )}
      </Box>
    );
  },
  () => true,
);

export function findAllValuesWithKey(obj: object, targetKey: string) {
  let values: any[] = [];

  function search(obj: { [key: string]: any }) {
    if (typeof obj !== "object" || obj === null) {
      return;
    }
    for (let key in obj) {
      if (key === targetKey) {
        values.push(obj[key]);
      }
      search(obj[key]);
    }
  }

  search(obj);
  return [...new Set(values)];
}
